import { render, staticRenderFns } from "./write-off-list.vue?vue&type=template&id=01dc3985"
import script from "./write-off-list.vue?vue&type=script&lang=js"
export * from "./write-off-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports